<template>
  <div class="itemBox">
    <div class="title">{{ title }}</div>
    <Form
      ref="permissionForm"
      label-position="right"
      :label-width="90"
      :rules="validate"
      :model="formItem"
    >
      <FormItem label="角色成员" prop="role">
        <Input v-model="formItem.role" />
      </FormItem>
      <FormItem label="操作权限" prop="permission">
        <CheckboxGroup v-model="formItem.permission">
          <Checkbox label="checked">
            <span>查看</span>
          </Checkbox>
          <Checkbox label="export">
            <span>导出</span>
          </Checkbox>
          <Checkbox label="delete">
            <span>删除</span>
          </Checkbox>
        </CheckboxGroup>
      </FormItem>
      <FormItem label="数据行权限" prop="colPermission">
        <RadioGroup v-model="formItem.colPermission">
          <Radio label="wofaqide">
            <span>我发起的</span>
          </Radio>
          <Radio label="quangongsi">
            <span>全公司的</span>
          </Radio>
          <Radio label="tongji">
            <span>同级的</span>
          </Radio>
          <Radio label="xiashu">
            <span>下属的</span>
          </Radio>
        </RadioGroup>
      </FormItem>
    </Form>
  </div>
</template>
<script>
export default {
  name: 'PermissionItem',
  props: ['formItem', 'title', 'validate'],
  data() {
    return {};
  },
  methods: {}
};
</script>
<style lang="less" scoped>
.itemBox {
  background-color: #eee;
  padding: 30px 20px 20px;
  margin-bottom: 10px;
  .title {
    margin-bottom: 20px;
    font-size: 16px;
  }
}
</style>
